module.exports = __webpack_public_path__ + "static/media/umbra-staff.a7791a30.png";